<ng-container>
  <ion-progress-bar
    *ngIf="name === 'progressBar'; else spinner"
    [type]="type"
  ></ion-progress-bar>
</ng-container>
<ng-template #spinner>
  <ion-spinner [name]="name"></ion-spinner>
</ng-template>
